import { Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { BackButton } from '../components/BackButton'
import ContactCard from '../components/ContactCard'
import { PageContainer } from '../components/layout/PageContainer'
import YesNoAction from '../components/YesNoAction'
import {
  selectAllFarmerAccounts,
  selectContactInfo,
  selectCurrentFarmerAccount,
} from '../features/azure-b2c/storage'
import { TestIds } from '../testIds'

export const PromoOrderSuccess = () => {
  const farmlandsAccounts = useSelector(selectAllFarmerAccounts)
  const currentAccount = useSelector(selectCurrentFarmerAccount)
  const navigate = useNavigate()

  const relationshipOwner = useSelector(selectContactInfo)

  const [account, setAccount] = useState<string | undefined>()

  useEffect(() => {
    if (!account) {
      setAccount(currentAccount?.accountNumber)
    } else if (account !== currentAccount?.accountNumber) {
      navigate('/account')
    }
  }, [currentAccount])

  return (
    <PageContainer data-testid={TestIds.pages.cart}>
      <BackButton text='Home' onClick={() => navigate('/home')} />
      <>
        <YesNoAction
          display='Order Submitted'
          subheading={
            <Typography variant='h4' sx={{ mt: 4, mb: 2 }}>
              Thanks {farmlandsAccounts?.contactFirstName}!
            </Typography>
          }
          body={
            <Typography variant='body2'>
              We have received your order and will send you an email confirmation before processing
              it. <br />
              If any additional information is needed, we will reach out to you directly. Thank you
              for your purchase!
            </Typography>
          }
        />
        <ContactCard
          sx={{ mt: 4 }}
          title='If you have any questions please contact your Farmlands representative.'
          data-testid={TestIds.components.contactCard.card}
          {...relationshipOwner}
        />
      </>
    </PageContainer>
  )
}
